
import React from 'react';
import type { ProductVariant } from '@/types/product';
import SizeSelector from './variant-selectors/SizeSelector';
import ColorSelector from './variant-selectors/ColorSelector';

interface VariantSelectorProps {
  variants: ProductVariant[];
  selectedVariant: ProductVariant;
  onVariantChange: (variant: ProductVariant) => void;
  hasColors: boolean;
  hasSizes: boolean;
}

const VariantSelector: React.FC<VariantSelectorProps> = ({
  variants,
  selectedVariant,
  onVariantChange,
  hasColors,
  hasSizes,
}) => {
  // Trier les variants par position pour garantir l'ordre correct
  const sortedVariants = React.useMemo(() => {
    return [...variants].sort((a, b) => (a.position || 0) - (b.position || 0));
  }, [variants]);

  console.log("VariantSelector: Props reçues", { 
    hasColors, 
    hasSizes, 
    variants: sortedVariants.map(v => `${v.size} - ${v.colorName} (pos: ${v.position})`) 
  });

  return (
    <div className="space-y-6">
      {/* Affichage TOTALEMENT indépendant des tailles */}
      {hasSizes && (
        <SizeSelector
          variants={sortedVariants}
          selectedVariant={selectedVariant}
          onVariantChange={onVariantChange}
        />
      )}

      {/* Affichage TOTALEMENT indépendant des couleurs */}
      {hasColors && (
        <ColorSelector
          variants={sortedVariants}
          selectedVariant={selectedVariant}
          onVariantChange={onVariantChange}
        />
      )}
    </div>
  );
};

export default VariantSelector;
